/* eslint-disable new-cap */

import { getRoute } from 'Config';

import { verifyRoute, verifyRouteSuccess } from 'Store/loading/actions';
import {
  handleLoginRoute as handleLoginRouteAction,
  navigate,
  verifyAgeVerificationDeeplinkRoute as verifyAgeVerificationDeeplinkAction,
  verifyCampaignDeeplinkRoute as verifyCampaignDeeplinkAction,
  verifyConfirmationDeeplinkRoute as verifyConfirmationDeeplinkRouteAction,
  verifyEmailRemovalDeeplinkRoute as verifyEmailRemovalDeeplinkRouteAction,
  verifyEmailSubscriptionTokenRoute as verifyEmailSubscriptionTokenRouteAction,
  verifyExploreRoute as verifyExploreRouteAction,
  verifyGoldDeeplinkRoute as verifyGoldDeeplinkAction,
  verifyGoldRoute as verifyGoldRouteAction,
  verifyIncentivesDeeplinkRoute as verifyIncentivesDeeplinkRouteAction,
  verifyMerchandisingRoute as verifyMerchandisingRouteAction,
  verifyMessagesRoute as verifyMessagesRouteAction,
  verifyMutualFriendsRoute as verifyMutualFriendsRouteAction,
  verifyNavigateRoute as verifyNavigateRouteAction,
  verifyPlusRoute as verifyPlusRouteAction,
  verifyPreferencesRoute as verifyPreferencesRouteAction,
  verifyPromoRoute as verifyPromoRouteAction,
  verifySettingsRoute as verifySettingsRouteAction,
  verifyWebProfileRoute as verifyWebProfileRouteAction,
} from 'Store/routing/actions';

// react-router onEnter adapter, with refresh / transition handling split
function RouteHandler(refreshHandler) {
  return ({ dispatch, search }) =>
    (nextState) => {
      refreshHandler({ dispatch, search }, nextState);
    };
}

function Redirect(to) {
  return ({ dispatch, search = '' }) => {
    dispatch(verifyRoute());
    // redirect with query param
    dispatch(navigate(`${to}${search}`));
    dispatch(verifyRouteSuccess());
  };
}

/**
 * DESCRIPTION
 *   - routes whoose verification needs access to the store are handled in sagas,
 *     while a route is being verified, the loading screen is being displayed
 *   FLOW
 *     1. dispatch(verifyRoute)
 *       - increments global loading state synchronously
 *       - set loading state to true
 *     2. dispatch(action)
 *       - triggers a saga which decides whether a redirect is necessary
 *     3. saga calls dispatch(verifyRouteSuccess) when finished
 *       - removes loading
 */
function Saga(actionCreator) {
  return ({ dispatch }, nextState) => {
    dispatch(verifyRoute());
    dispatch(actionCreator(nextState));
  };
}

export const verifyMessagesRoute = RouteHandler(
  Saga(({ params: { matchId } }) => verifyMessagesRouteAction(matchId))
);

export const verifyMutualFriendsRoute = RouteHandler(Saga(() => verifyMutualFriendsRouteAction()));

export const verifyPlusRoute = RouteHandler(Saga(() => verifyPlusRouteAction()));

export const verifyMerchandisingRoute = RouteHandler(Saga(() => verifyMerchandisingRouteAction()));

export const verifyGoldRoute = RouteHandler(Saga(() => verifyGoldRouteAction()));

export const verifySettingsRoute = RouteHandler(Saga(() => verifySettingsRouteAction()));

export const verifyPhotoFileRoute = RouteHandler(Redirect(getRoute('editProfile')));

export const verifyCheckoutRoute = RouteHandler(Redirect(getRoute('recs')));

export const redirectToRecs = RouteHandler(Redirect(getRoute('recs')));

export const redirectToExplore = RouteHandler(Redirect(getRoute('explore')));

export const redirectToSettings = RouteHandler(Redirect(getRoute('settings')));

export const redirectToGiftCard = RouteHandler(
  Redirect(getRoute('giftCard', {}, { withPrefix: false }))
);

export const redirectToRoot = RouteHandler(Redirect(getRoute('login', {}, { withPrefix: false })));

export const verifyConfirmationDeeplinkRoute = RouteHandler(
  Saga(({ params: { type, otp } }) => verifyConfirmationDeeplinkRouteAction({ type, otp }))
);

export const verifyEmailRemovalDeeplinkRoute = RouteHandler(
  Saga(({ params: { otp } }) => verifyEmailRemovalDeeplinkRouteAction({ otp }))
);

export const verifyCampaignDeeplinkRoute = RouteHandler(
  Saga(({ params: { otp, campaignInfo } }) => verifyCampaignDeeplinkAction({ otp, campaignInfo }))
);

export const verifyAgeVerificationDeeplinkRoute = RouteHandler(
  Saga(({ params: { status } }) => verifyAgeVerificationDeeplinkAction({ status }))
);

export const verifyGoldDeeplinkRoute = RouteHandler(Saga(() => verifyGoldDeeplinkAction()));

export const verifyEmailSubscriptionTokenRoute = RouteHandler(
  Saga(() => verifyEmailSubscriptionTokenRouteAction())
);

export const verifyIncentivesDeeplinkRoute = RouteHandler(
  Saga(({ params: { promoCode } }) => verifyIncentivesDeeplinkRouteAction({ promoCode }))
);

export const handleLoginRoute = RouteHandler(Saga(() => handleLoginRouteAction()));

export const verifyPromoRoute = RouteHandler(Saga(() => verifyPromoRouteAction()));

export const verifyNavigateRoute = RouteHandler(
  Saga(({ params: { route } }) => verifyNavigateRouteAction({ route }))
);

export const verifyWebProfileRoute = RouteHandler(
  Saga(({ params: { username } }) => verifyWebProfileRouteAction({ username }))
);

export const verifyExploreRoute = RouteHandler(Saga(() => verifyExploreRouteAction()));

export const verifyPreferencesRoute = RouteHandler(Saga(() => verifyPreferencesRouteAction()));
